import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { FaRegHandPointer } from 'react-icons/fa';

import styles from './JoinGame.module.css';

export type JoinGameProps = {
    username: string;
    onClick?: () => void;
    /** Drapeaux de langue (rendu vide là où le choix n'est pas proposé). */
    languagePicker?: ReactNode;
};

export function JoinGame({ username, onClick, languagePicker }: JoinGameProps) {
    const { t } = useTranslation();

    return (
        <div className={styles.container}>
            <div className={styles.topbar}>
                <img className={styles.logo} src="/assets/images/logo-unboared-sm-tr.png" alt="Unboared" />
            </div>

            <div className={styles.greet}>
                <span className={styles.hi}>{t('gamepad.join.greeting')}</span>
                <span className={styles.name}>{username} ✌️</span>
            </div>

            <div className={styles.tapwrap}>
                <button type="button" className={styles.tapcard} onClick={onClick}>
                    <span className={styles.ripple} />
                    <span className={styles.ripple2} />
                    <span className={styles.hand}>
                        <FaRegHandPointer />
                    </span>
                    <span className={styles.tapTitle}>{t('gamepad.join.tap')}</span>
                    <span className={styles.tapHint}>{t('gamepad.join.tapHint')}</span>
                </button>
            </div>

            {/* Sous la carte : les drapeaux arrivent après une lecture réseau, au-dessus ils
                pousseraient la carte « Touche pour jouer » sous le doigt du joueur. */}
            {languagePicker && <div className={styles.language}>{languagePicker}</div>}
        </div>
    );
}
